import {
  SplitModuleContainerFields,
  SplitModuleContainerMediaItem,
  SplitModuleContainerParams,
  SplitModuleContainerProps,
} from '../types/splitModuleContainer.types';
import { LinkField, StringField, THeadingTag } from '../../../../types/types';
import { TMediaCarouselSlide } from '../../mediaCarousel/types/mediaCarousel.types';
import { getThumbnailProps } from '../../../../utils/youtube.utils';
import { getImageField } from '../../../../utils/getImageFields';

export class SplitModuleContainerModel {
  private readonly fields: SplitModuleContainerFields | undefined;
  private readonly params: SplitModuleContainerParams | undefined;
  readonly uid: string | undefined;

  constructor(props: SplitModuleContainerProps) {
    this.fields = props?.fields;
    this.params = props?.params;
    this.uid = props?.rendering?.uid || '';
  }

  get id(): string {
    return this.uid?.slice?.(1, this.uid.length - 1) || '';
  }

  get bodyText(): StringField {
    return this.fields?.bodyText || {};
  }

  get eyebrow(): StringField {
    return this.fields?.eyebrow || {};
  }

  get title(): StringField {
    return this.fields?.title || {};
  }

  get link1(): LinkField | undefined {
    return this.fields?.link1;
  }

  get link2(): LinkField | undefined {
    return this.fields?.link2;
  }

  get downloadButtonLink(): LinkField | undefined {
    return this.fields?.downloadButtonLink;
  }

  get items(): SplitModuleContainerMediaItem[] {
    return this.fields?.items || [];
  }

  get slides(): TMediaCarouselSlide[] {
    return this.items?.map(({ fields }) => {
      const { thumbnailImgSrc } = getThumbnailProps(fields?.video?.value?.href || '');
      const desktopImage = getImageField(fields?.image, thumbnailImgSrc || '', fields?.useVideo?.value);
      const mobileImage = getImageField(fields?.mobileImage, thumbnailImgSrc || '', fields?.useVideo?.value);
      return {
        isVideo: fields?.useVideo?.value,
        videoUrl: fields?.video,
        editorialImageProps: {
          desktopImage: desktopImage,
          mobileImage: mobileImage,
          desktopTransformation: 'Size1000',
          mobileTransformation: 'Size500',
        },
      };
    });
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h3';
  }

  get imagePosition(): 'left' | 'right' {
    return this.params?.imagePosition || 'left';
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
